import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from '../../Assets/images/Airswift Primary Logo (Black Text).png';
import styles from './RightToBeForgotten.module.scss';
import { validationMessages } from '../../utils/constants';
import ValidationErrorLabel from '../../Components/common/ValidationErrorLabel/ValidationErrorLabel';
import { emailRegExp } from '../../utils/regexps';

function MainForm({ submit }) {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({ name: '', mail: '' });

  const isFormValid = () => {
    const initErrors = { name: '', mail: '' };

    if (!username) {
      initErrors.name = validationMessages(t).USERNAME_REQUIRED;
    }
    if (!email.match(emailRegExp)) {
      initErrors.mail = validationMessages(t).EMAIL_INVALID;
    }
    if (!email) {
      initErrors.mail = validationMessages(t).EMAIL_REQUIRED;
    }

    setErrors(initErrors);
    return !(!!initErrors.name || !!initErrors.mail);
  };

  const submitHandler = (e) => {
    if (!isFormValid()) {
      e.preventDefault();
    } else {
      submit();
    }
  };

  return (
    <>
      <div className={`mb-3 ${styles.form}`}>
        <div className={styles.form__inputField}>
          <label className={styles.label} htmlFor="name">
            {t('profile.rtbf.name')}*
          </label>
          <input value={username} onChange={(e) => setUsername(e.target.value)} className={styles.input} type="text" />
          {errors.name && <ValidationErrorLabel message={errors.name} />}
        </div>
        <div className={styles.form__inputField}>
          <label className={styles.label} htmlFor="email">
            {t('profile.rtbf.email')}*
          </label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} className={styles.input} type="text" />
          {errors.mail && <ValidationErrorLabel message={errors.mail} />}
        </div>
      </div>
      <p className={styles.policy}>{t('profile.rtbf.footertext')}</p>
      <a
        onClick={submitHandler}
        className={styles.mailLink}
        href={`mailto:dpo@airswift.com?subject=Right to be forgotten
            &body=
            Dear DPO.
            The user ${username} has requested the Right to Be Forgotten. 
            Please review this request and advise accordingly within 1 calendar month.
            Thank you.`}
      >
        <button className={` mt-4 ${styles.btn}`}>{t('common.general.submit')}</button>
      </a>
    </>
  );
}

function RightToBeForgotten() {
  const { t } = useTranslation();

  const [isSent, setIsSent] = useState(false);

  return (
    <div className={`col px-1 px-sm-5 mb-3 ${styles.rtfb}`}>
      <Link to="/dashboard">
        <img className={`mb-3 ${styles.rtfb__image}`} src={logo} alt="" />
      </Link>
      <div className={`py-5 ${styles.rtfb__content}`}>
        <p className={styles.title}>{isSent ? t('profile.rtbf.thankyoutitle') : t('profile.rtbf.title')}</p>
        <p className={styles.subtitle}>{isSent ? t('profile.rtbf.thankyousubtitle') : t('profile.rtbf.description')}</p>
        {isSent ? (
          <p className={styles.policy}>{t('profile.rtbf.thankyoupolicy')}</p>
        ) : (
          <MainForm submit={() => setIsSent(true)} />
        )}
      </div>
    </div>
  );
}

export default RightToBeForgotten;
